import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE_DISPLAY, PHONE_TEL } from "@/data/content";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.22em] ${dark ? "text-bone/60" : "text-stonemuted"}`}>
    {children}
  </p>
);

export const SectionHeading = ({ eyebrow, title, dark = false, className = "" }) => (
  <div className={className}>
    <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
    <h2 className={`mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight leading-tight ${dark ? "text-bone" : "text-obsidian"}`}>
      {title}
    </h2>
  </div>
);

export const EstimateButton = ({ className = "", label = "Book", testId = "cta-estimate-button" }) => (
  <Link
    to="/estimate"
    data-testid={testId}
    className={`group inline-flex items-center gap-2 bg-teak text-bone px-6 py-3.5 font-semibold text-sm tracking-wide shadow-lg shadow-teak/25 transition-all duration-300 hover:bg-teakdark hover:shadow-teak/40 hover:-translate-y-0.5 ${className}`}
  >
    {label}
    <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
  </Link>
);

export const CallButton = ({ className = "", dark = false, testId = "cta-call-button" }) => (
  <a
    href={PHONE_TEL}
    data-testid={testId}
    className={`inline-flex items-center gap-2 px-6 py-3.5 font-semibold text-sm tracking-wide border transition-colors duration-300 ${
      dark
        ? "border-bone/30 text-bone hover:bg-bone hover:text-obsidian"
        : "border-obsidian/25 text-obsidian hover:bg-obsidian hover:text-bone"
    } ${className}`}
  >
    <Phone size={15} />
    Call {PHONE_DISPLAY}
  </a>
);

export const ProjectsButton = ({ className = "", testId = "cta-projects-button" }) => (
  <Link
    to="/projects"
    data-testid={testId}
    className={`group inline-flex items-center gap-2 px-6 py-3.5 font-semibold text-sm tracking-wide border border-obsidian/25 text-obsidian hover:bg-obsidian hover:text-bone transition-colors duration-300 ${className}`}
  >
    View Our Projects
    <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
  </Link>
);
